import React from "react";
const loadMessageV3 = props => {
  return (
     <>
     {props.idLoading?
     	<>
     		<div  className="loadingBG">
					 
				 </div>
     	
				<div  className="loadingBG2">
					 <div  className="loading" >
					 	<div className="xext-loader-card" role="status" aria-live="polite">
					 		<div className="xext-loader-ring" aria-hidden="true">
					 			<span className="xext-loader-core"></span>
					 		</div>
					 		<div className="xext-loader-copy">
					 			<strong>Cargando</strong>
					 			<small>Preparando la vista</small>
					 		</div>
					 	</div>
					 </div>
				 </div></>
			:""}
       </>
  );

};

export default loadMessageV3;
				 
